import iHeartSoundPlusLogo from "./rcscloud.png";

const SoundPlusLogoTitle = () => (
  <div style={{ display: "flex", alignItems: "center" }}>
    <img src={iHeartSoundPlusLogo} alt="RCS Cloud Logo" style={{ width: "10%" }} />
    <h1 className="title">Release Notes Tool</h1>
  </div>
);

export default SoundPlusLogoTitle;
